export default "__VITE_ASSET__DX5xjSwP__"